import { SearchEnrollmentDto } from "../dto/search-enrollment.dto";
import { SearchEnrollmentResponse } from "../../../../domain/model/search/search-enrollment-response";
import { MapperService } from "../../../../base/mapper.service";
import { DataBodyResponse } from "src/app/base/model/data-body-response";
import { grep } from "jquery";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";

export class SearchEnrollmentMapper extends MapperService<DataBodyResponse<[SearchEnrollmentResponse]>, ProcessedDataResponse<SearchEnrollmentDto>> {

    map(response: DataBodyResponse<[SearchEnrollmentResponse]>): ProcessedDataResponse<SearchEnrollmentDto> {
        var processedDataResponse = new ProcessedDataResponse<SearchEnrollmentDto>()
        processedDataResponse.code = response?.code;
        if (processedDataResponse.code == -9999) {
            console.log("findEnrollmentPersonTMV: " + response?.message)

            var filteredDeleted = grep(response?.data, function (n, i) {
                !n.firstName?.includes
                return !n.firstName?.toUpperCase().includes('_DEL') &&
                    !n.middleName?.toUpperCase().includes('_DEL') &&
                    !n.lastName?.toUpperCase().includes('_DEL') &&
                    !n.email?.toUpperCase().includes('_DEL') &&
                    !n.ssn?.toUpperCase().includes('_DEL') &&
                    !n.identification?.toUpperCase().includes('_DEL') &&
                    !n.birthDate?.toUpperCase().includes('_DEL') &&
                    !n.lastUpdateUser?.nameUser?.toUpperCase().includes('_DEL') &&
                    !n.lastUpdateUser?.cacName?.toUpperCase().includes('_DEL');
            });

            if (filteredDeleted.length > 0) {
                processedDataResponse.data = {
                    name: filteredDeleted[0].firstName ? filteredDeleted[0].firstName : "" + "" + filteredDeleted[0].middleName ? filteredDeleted[0].middleName : "" + "" + filteredDeleted[0].lastName ? filteredDeleted[0].lastName : "",
                    email: filteredDeleted[0].email ? filteredDeleted[0].email : "",
                    curp: filteredDeleted[0].ssn ? filteredDeleted[0].ssn : "",
                    rfc: filteredDeleted[0].identification ? filteredDeleted[0].identification : "",
                    birthDay: filteredDeleted[0].birthDate ? filteredDeleted[0].birthDate : "",
                    agent: filteredDeleted[0].lastUpdateUser?.nameUser ?? "",
                    sucursal: filteredDeleted[0].lastUpdateUser?.cacName ?? "",
                    operationStatus: filteredDeleted[0].operation,
                    personId: filteredDeleted[0].id
                };
                return processedDataResponse
            } else {
                processedDataResponse.code = 0
                processedDataResponse.error = 'Error en la busqueda, no se encontraron coincidencias'
                return processedDataResponse
            }
        } else {
            processedDataResponse.error = response?.error || response?.error != '' ? response?.error : 'Error en el servicio, intentar más tarde'
            return processedDataResponse
        }
    }
}